import React from 'react';
import { mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import { StyledCloseIcon } from './Modal.styles';
const ModalCloseIcon = ({ showCloseIcon, onClose }) => {
    if (showCloseIcon)
        return (React.createElement(StyledCloseIcon, { "aria-label": "close modal", onClick: onClose },
            React.createElement(Icon, { path: mdiClose })));
    return null;
};
export default ModalCloseIcon;
//# sourceMappingURL=ModalCloseIcon.js.map